import type { ReactElement, ReactNode } from 'react'
import { Group, type GroupProps, Stack, Text, Title } from '@mantine/core'
import { Size } from '@front/model'

export type SectionHeadingProps = Omit<GroupProps, 'title' | 'children' | 'description'> & {
  title: string | ReactNode
  children?: ReactNode
  description?: string | ReactNode
}

export const SectionHeading = ({ title, children, description, ...props }: SectionHeadingProps): ReactElement => {
  return (
    <Group justify='space-between' px={Size.space['2xl']} {...props}>
      <Stack gap={Size.space.sm}>
        <SectionHeadingTitle title={title} />
        {typeof description === 'string' ? (
          <Text c='dimmed' size='sm'>
            {description}
          </Text>
        ) : (
          description
        )}
      </Stack>
      {children}
    </Group>
  )
}

export const SectionHeadingTitle = ({ title }: { title: string | ReactNode }): ReactNode => {
  if (typeof title === 'string') return <Title order={4}>{title}</Title>
  return title
}
